import { Params } from '@angular/router';
import { SCHOOL_ROUTE } from 'app/teachers/school/school-routing.constant';

export const TEACHERS_ROUTE = {
  CLASS_MANAGEMENT: {
    name: 'classes',
    route(): string[] {
      return [...TEACHERS_ROUTE.route(), this.name];
    },
    queryParams(addClass: boolean): Params {
      return {
        AddClass: encodeURI(String(addClass))
      };
    }
  },
  CREDITS: {
    name: 'credits',
    route(): string[] {
      return [...TEACHERS_ROUTE.route(), this.name];
    }
  },

  DEFAULT: '',
  defaultRedirectRoute(): string {
    const route = TEACHERS_ROUTE.CLASS_MANAGEMENT.route();
    if (route[0].startsWith('/')) {
      route[0] = route[0].slice(0);
    }

    return route.join('/');
  },

  FINISH_REGISTRATION: {
    name: 'finishregistration',
    route(): string[] {
      return [...TEACHERS_ROUTE.route(), this.name];
    }
  },
  NO_LICENSE: {
    name: 'nolicense',
    route(): string[] {
      return [...TEACHERS_ROUTE.route(), this.name];
    }
  },
  SETTINGS: {
    name: 'settings',
    route(): string[] {
      return [...TEACHERS_ROUTE.route(), this.name];
    }
  },
  name: 'teachers',
  SUBSCRIBE: {
    name: 'subscribe',
    route(): string[] {
      return [...TEACHERS_ROUTE.route(), this.name];
    }
  },
  REFERRAL: {
    name: 'referral',
    route(): string[] {
      return [...TEACHERS_ROUTE.route(), this.name];
    }
  },
  HELP_CENTER: {
    name: 'helpcenter',
    route(): string[] {
      return [...TEACHERS_ROUTE.route(), this.name];
    }
  },
  route(): string[] {
    return ['/' + this.name];
  },
  SCHOOL: SCHOOL_ROUTE,
  MERGE_ACCOUNT: {
    name: 'merge-account',
    route(): string[] {
      return [...TEACHERS_ROUTE.route(), this.name];
    }
  },
  MERGE_COMPLETE: {
    name: 'merge-complete',
    route(): string[] {
      return ['/' + this.name];
    }
  },
  MERGE_ACCOUNT_SEND_EMAIL: {
    name: 'merge-account-send-email',
    queryParams(displayName: string, email:string): Params {
      return {
        displayName: displayName,
        email: email
      };
    },
    route(): string[] {
      return [...TEACHERS_ROUTE.route(), this.name];
    }
  },
  MERGE_ACCOUNT_CONFIRMATION: {
    name: 'merge-account-confirmation',
    queryParams(displayName: string, email:string): Params {
      return {
        displayName: displayName,
        email: email
      };
    },
    route(): string[] {
      return [...TEACHERS_ROUTE.route(), this.name];
    }
  }
};
